import { useEffect } from 'react';
import style from './wallet.module.css'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { showWalletAtom, walletInfoAtom, lastGenerateInfoAtom, textGenerateAtom, subscriptionsInfoAtom, balanceAtom } from '../../../store'
import walletimg from '../../../assets/wallet.png'
import groupWalletimg from '../../../assets/groupWallet.png'
import { useTranslation } from "react-i18next";

const Wallet = ({ type, mandatory = false }) => {
  const balance = useRecoilValue(balanceAtom);
  const [lastGenerateInfo, setLastGenerateInfo] = useRecoilState(lastGenerateInfoAtom);
  const [walletInfo, setWalletInfo] = useRecoilState(walletInfoAtom);
  const [showWallet, setShowWallet] = useRecoilState(showWalletAtom);
  const setTextGenerate = useSetRecoilState(textGenerateAtom);
  const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      setShowWallet({
        open: false,
        type: ''
      })
      setTextGenerate(false)
    }
  }, [])

  const handlerConfirm = () => {
    if (showWallet.type === 'text') {
      setTextGenerate(true)
    }
    setShowWallet({
      open: false,
      type: ''
    })
    setWalletInfo({
      ...walletInfo,
      confirm: true
    })

    setLastGenerateInfo({
      ...lastGenerateInfo,
      privateType: walletInfo.type
    })
  }

  const handlerCheckGroup = () => {
    setWalletInfo({
      ...walletInfo,
      type: 'Group'
    })
  }

  const handlerCheckPersonal = () => {
    if (mandatory) return
    setWalletInfo({
      ...walletInfo,
      type: 'Personal'
    })
  }

  const walletComponent = {
    "imageWallet": <div
      className={style.wallet}>
      <div className={style.walletMain}>
        <div
          className={style.walletTitle}>{t('WALLET_CHOOSE_TITLE')}</div>
        <div className={style.walletBox}>

          <div
            className={`${style.group} ${walletInfo.type === 'Group' ? style.select : ''}`}
            onClick={handlerCheckGroup}
            style={type === "modal" ? {
              width: "85%",
              height: 70,
              lineHeight: '44px'
            } : {}}>
            <div className={style.left}>
              <img src={groupWalletimg} alt="groupWalletimg" />
              <span>Group</span>
            </div>
            <div className={style.right}>
              {balance.groupBalance / 10}
            </div>
          </div>

          <div
            className={`${style.personal} ${walletInfo.type === 'Personal' ? style.select : ''} ${mandatory ? style.disable : ''}`}
            onClick={handlerCheckPersonal}
          >
            <div className={style.left}>
              <img src={walletimg} alt="walletimg" />
              <span>Personal</span>
            </div>
            <div className={style.right}>
              {(balance.selfBalance + subscriptionsInfo.wallet_balance) / 10}
            </div>

          </div>
        </div>
        <div
          className={style.confirmBtn}
          onClick={handlerConfirm}
        >Confirm</div>
      </div>
    </div >,
    "textWallet": <div
      className={style.modalWallet}
    >
      <div className={style.walletMain}>
        <div
          className={style.walletTitle}
          style={{
            marginBottom: '50px',
            fontSize: 40
          }}>{t('WALLET_CHOOSE_TITLE')}</div>
        <div className={style.walletBox}>

          <div
            className={`${style.group} ${walletInfo.type === 'Group' ? style.select : ''}`}
            onClick={handlerCheckGroup}
            style={{
              width: "85%",
              height: 70,
              lineHeight: '44px'
            }}>
            <div className={style.left}>
              <img src={groupWalletimg} alt="groupWalletimg" />
              <span>Group</span>
            </div>
            <div className={style.right}>
              {balance.groupBalance / 10}
            </div>
          </div>

          <div
            className={`${style.personal} ${walletInfo.type === 'Personal' ? style.select : ''} ${mandatory ? style.disable : ''}`}
            onClick={handlerCheckPersonal}
            style={{
              width: "85%",
              height: 70,
              lineHeight: '44px',
              marginBottom: '22px',
            }}
          >
            <div className={style.left}>
              <img src={walletimg} alt="walletimg" />
              <span>Personal</span>
            </div>
            <div className={style.right}>
              {(balance.selfBalance + subscriptionsInfo.wallet_balance) / 10}
            </div>

          </div>
        </div>
        <div
          className={style.confirmBtn}
          style={{
            width: "85%",
            height: 46,
            lineHeight: '44px',
            marginBottom: '50px',
          }}
          onClick={handlerConfirm}
        >Confirm</div>
      </div>
    </div >
  }

  return walletComponent[type]
}

export { Wallet }